import AuthService from '../authService';
import ThirdPartyJobPaymentsItem from '../../Domain/ThirdParty/ThirdPartyJobPayments/ThirdPartyJobPaymentsItem';
import serviceHelper from '../../Helpers/serviceHelper';
import objectHelper from '../../Helpers/objectHelper';
import TpEvaluatorTpJobPaymentClientInvoiceItem from '../../Domain/TpEvaluatorTpJobPaymentClientInvoiceItem';
import ThirdPartyJobPaymentForExportPaymentItem from '../../Domain/ThirdParty/ThirdPartyJobPayments/ThirdPartyJobPaymentForExportPaymentItem';
import SearchParams from '../../Elements/SearchParams';
import TpEvaluatorTpJobPaymentSearchParams from '../../Contents/Operations/TpClientInvoice/Details/TpEvaluatorTpJobPaymentSearchParams';
import ExcludedTpJobPayEvaluatorsSearchParams from '../../Contents/ThirdParty/TpEvaluatorTpJobPayments/ThirdPartyJobPayments/ExcludedTpJobPayEvaluatorsSearchParams';
import ThirdPartyJobPaymentsAdminSearchParams from '../../Contents/ThirdParty/TpEvaluatorTpJobPayments/ThirdPartyJobPayments/ThirdPartyJobPaymentsAdminSearchParams';

export default class ThirdPartyJobPaymentsService {
  static GetTpEvaluatorTpJobPayments(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, ThirdPartyJobPaymentsAdminSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/TpEvaluatorTpJobPayment/GetItems/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new ThirdPartyJobPaymentsItem(item)) : [];
  }

  static ConvertDBItemsForExportPayment(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new ThirdPartyJobPaymentForExportPaymentItem(item)) : [];
  }

  static ActionByCommand(command, item) {
    const searchParams = new SearchParams(item.SearchItem, ThirdPartyJobPaymentsAdminSearchParams, '', '', 1, 2147483647);

    const idsWithReason = {
      Command: command,
      SelectedIds: item.Ids,
      Reason: item.Reason,
      Surcharge: item.Surcharge,
      AllItemsInTheSearchSetAreSelected: item.AllItemsInTheSearchSetAreSelected,
      SearchParams: searchParams.serializeForBackendCall(),
    };
    const url = `/api/TpEvaluatorTpJobPayment/ActionByCommand/`;
    const idsWithReasonJson = JSON.stringify(idsWithReason);

    return AuthService.getInstance().CallBackendFunctionPut(url, idsWithReasonJson);
  }

  static Approve(item) {
    return ThirdPartyJobPaymentsService.ActionByCommand('Approve', item);
  }

  static Void(item) {
    return ThirdPartyJobPaymentsService.ActionByCommand('Void', item);
  }

  static VoidAndReissue(item) {
    return ThirdPartyJobPaymentsService.ActionByCommand('Void and Reissue', item);
  }

  static VoidAndSupress(item) {
    return ThirdPartyJobPaymentsService.ActionByCommand('Void and Supress', item);
  }

  static GenerateAssignmentPayment(item, searchItem, allItemsInTheSearchAreSelected) {
    const searchParams = new SearchParams(searchItem, ExcludedTpJobPayEvaluatorsSearchParams, '', '', 1, 2147483647);

    const createPayload = {
      SelectedIds: item,
      AllItemsInTheSearchSetAreSelected: allItemsInTheSearchAreSelected,
      SearchParams: searchParams.serializeForBackendCall(),
    };

    const createPayloadJson = JSON.stringify(createPayload);

    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/TpEvaluatorTpJobPayment/GenerateAssignmentPayment/',
      createPayloadJson
    );
  }

  static IsNewPaymentRequestButtonEnabled(id) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpEvaluatorTpJobPayment/IsNewPaymentRequestButtonEnabled/${id}`
    );
  }

  static IsNewAdvancePaymentButtonEnabled(id) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpEvaluatorTpJobPayment/IsNewAdvancePaymentButtonEnabled/${id}`
    );
  }

  static UpsertEvaluatorPayment(item) {
    item = serviceHelper.ConvertAllPropertyToString(item);

    if (item.TpEvaluatorTpJobPaymentId === '') {
      return AuthService.getInstance().CallBackendFunctionPost(
        '/api/TpEvaluatorTpJobPayment/PostPaymentRequestAsync',
        JSON.stringify(item)
      );
    }

    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/TpEvaluatorTpJobPayment/EditEvaluatorPaymentAsync',
      JSON.stringify(item)
    );
  }

  static GetAvailableStatusNavigationActions(id) {
    const url = `/api/TpEvaluatorTpJobPayment/GetAvailableStatusNavigationActionsAsync/${id}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ExecuteWorkflowAction(actionPayload) {
    const string = objectHelper.toString(actionPayload);
    const json = JSON.stringify(string);
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/TpEvaluatorTpJobPayment/ExecuteWorkflowActionAsync/',
      json
    );
  }

  static GetTpEvaluatorTpJobPaymentsForClientInvoice(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(
      searchItem,
      TpEvaluatorTpJobPaymentSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );

    const url = `/api/TpEvaluatorTpJobPayment/GetItemsForClientInvoice/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItemsForClientInvoice(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new TpEvaluatorTpJobPaymentClientInvoiceItem(item)) : [];
  }

  static ExportToExcel(searchItem) {
    const searchParams = new SearchParams(searchItem, TpEvaluatorTpJobPaymentSearchParams, '', '', 0, 0);
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpEvaluatorTpJobPayment/ExportToExcel/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=false`
    );
  }
}
